import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, input, output, signal, viewChild } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'drawer-list-detail',
    templateUrl: './drawer-list-with-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatSidenavModule, RouterModule, NgTemplateOutlet]
})
export class DrawerListDetailComponent implements OnInit, OnDestroy {
    matDrawer = viewChild(MatDrawer);

    listComponent = input.required<any>();

    drawer = output<MatDrawer>();

    drawerMode = signal<'over' | 'side' >('over');

    private _unsubscribeAll: Subject<unknown> = new Subject<unknown>();

    constructor(
        private readonly _fuseMediaWatcherService: FuseMediaWatcherService,
        private readonly _cdRef: ChangeDetectorRef,
        private readonly _router: Router,
        private readonly _activatedRoute: ActivatedRoute,
    ) { }

    onBackdropClick(): void {
        // Go back to the list
        this._router.navigate(["./"], { relativeTo: this._activatedRoute });

        this._cdRef.markForCheck();
    }

    ngOnInit(): void {
        this.drawer.emit(this.matDrawer());

        this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1440px)')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((state) => {
                this.drawerMode.set( state.matches ? 'side' : 'over');
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
